import React, { useState } from 'react';
import { supabase } from '../supabaseClient';

const ContactUs = () => {
  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    email: '',
    phone: '',
    company: '',
    property_type: ''
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');

    const { error } = await supabase
      .from('contact_requests')
      .insert([formData]);

    if (error) {
      setMessage('Error submitting form. Please try again.');
    } else {
      setMessage('Thank you! We will contact you soon.');
      setFormData({
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        company: '',
        property_type: ''
      });
    }
    setLoading(false);
  };

  return (
    <div style={{ padding: '60px 0' }}>
      <div className="container" style={{ maxWidth: '600px' }}>
        <h2 style={{ textAlign: 'center', marginBottom: '30px' }}>Contact Us</h2>
        <p style={{ textAlign: 'center', marginBottom: '40px' }}>
          Book a Free Demo - Learn more about what we can do for your business.
        </p>
        
        <form onSubmit={handleSubmit}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
            <div className="form-group">
              <label>First Name *</label>
              <input
                type="text"
                name="first_name"
                value={formData.first_name}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label>Last Name *</label>
              <input
                type="text"
                name="last_name"
                value={formData.last_name}
                onChange={handleChange}
                required
              />
            </div>
          </div>
          
          <div className="form-group">
            <label>Email Address *</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>
          
          <div className="form-group">
            <label>Phone Number *</label>
            <input
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              required
            />
          </div>
          
          <div className="form-group">
            <label>Company Name *</label>
            <input
              type="text"
              name="company"
              value={formData.company}
              onChange={handleChange}
              required
            />
          </div>
          
          <div className="form-group">
            <label>Property Type *</label>
            <select
              name="property_type"
              value={formData.property_type}
              onChange={handleChange}
              required
            >
              <option value="">Select...</option>
              <option value="residential">Residential</option>
              <option value="commercial">Commercial</option>
              <option value="multifamily">Multifamily</option>
              <option value="single-family">Single-Family</option>
              <option value="affordable-housing">Affordable Housing</option>
              <option value="student-housing">Student Housing</option>
            </select>
          </div>
          
          <div style={{ marginBottom: '20px', fontSize: '14px', color: '#666' }}>
            By submitting this form, I acknowledge I have reviewed our Privacy Notice.
          </div>
          
          <button type="submit" className="btn btn-primary" disabled={loading} style={{ width: '100%' }}>
            {loading ? 'Submitting...' : 'Book a Free Demo'}
          </button>
        </form>
        
        {message && (
          <div style={{ marginTop: '20px', padding: '15px', background: '#f8f9fa', borderRadius: '4px', textAlign: 'center' }}>
            {message}
          </div>
        )}
      </div>
    </div>
  );
};

export default ContactUs;